export default function Header () {
  return (
    <div className='header'>
      Repo Finder
    </div>
  )
}
